import { Routes } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';

/**
 * Demonstrates static routes and CMS based routes.
 */
export const staticRoutes: Routes = [
  {
    path: 'page/faq',
    component: PageLayoutComponent,
    data: { pageLabel: '/faq' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'order/:orderCode',
    data: { pageLabel: '/order' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard],
  },
];
